import { z } from "zod";
export const AbrirTurnoCajaSchema = z.object({
    montoInicial: z.number().min(0, "El monto inicial no puede ser negativo").default(0),
    notas: z.string().max(500).optional().nullable(),
});
export const CerrarTurnoCajaSchema = z.object({
    montoFinalEfectivo: z.number().min(0, "El monto final reportado no puede ser negativo"),
    justificacionDiferencia: z.string().max(240).optional().nullable(),
    notas: z.string().max(500).optional().nullable(),
});
//# sourceMappingURL=turno-caja.schema.js.map